module.exports = __webpack_public_path__ + "static/media/45_tn.8522f7b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/45_tn.jpg
// module id = 258
// module chunks = 0